import { Component } from '@angular/core';

@Component({
  selector: 'app-shared-info-dialog',
  templateUrl: './shared-info-dialog.component.html',
  styleUrls: ['./shared-info-dialog.component.scss']
})
export class SharedInfoDialogComponent {

}
